import React from "react";
import ForgeAPI from "../../../../B_API/ForgeAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faFileExport,
  faFileImport,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fileDownload from "js-file-download";
import RenameLayerApi from "../../../../B_API/RenameLayerApi";
import {
  ExportTableToCSV,
  RemoveColNewLayerName,
} from "../../../../F_UTILS/CSVRenameLayerUtils";
import classNames from "classnames";
import { useSelector } from "react-redux";

export default function FooterComponent({
  setProgressIsRunning,
  setMessageProgress,
  setMessageCompleted,
  setShowDialog,
  originName,
  setListNames,
  setViewInfor,
  btnDisable,
}) {
  const jobId = useSelector((state) => state.jobId.current);

  function handleInputCsvClick() {
    const realFileInput = document.getElementById("input-file");
    realFileInput.value = "";
  }

  const handleDownload = async () => {
    try {
      console.log("click");
      setProgressIsRunning(true);
      setMessageProgress("ダウンロードの準備中。しばらくお待ちください。");
      setShowDialog(true);

      const res = await RenameLayerApi.DownloadFile(jobId);
      console.log(res.data);
      if (res.status === 200) {
        var date = new Date();
        var newName = `${date.getFullYear()}${
          date.getMonth() + 1
        }${date.getDate()}${date.getHours()}${date.getMinutes()}_${originName}`;
        fileDownload(res.data, newName);

        setProgressIsRunning(false);
        setMessageCompleted("ダウンロードが完了しました。");
      } else {
        toast.error("ダウンロード出来ませんでした。", {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setProgressIsRunning(false);
        setMessageCompleted("ダウンロード出来ませんでした。");
      }
    } catch (error) {
      console.log(error);
      toast.error("ダウンロード出来ませんでした。", {
        position: "bottom-center",
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      setProgressIsRunning(false);
      setMessageCompleted("ダウンロード出来ませんでした。");
    }
  };

  function handleInputCSVChange() {
    const realFileInput = document.getElementById("input-file");
    if (realFileInput.value) {
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        let dataCSV = fileReader.result.split("\n").map((e) => {
          return e.split(",");
        });
        let listLayers = [];
        for (let index = 0; index < dataCSV.length; index++) {
          const arr = dataCSV[index];
          if (arr[0] !== "") {
            if (arr.length === 8) {
              //layer cũ - rgb == thay đổi tên layer- màu mới rgb
              const oldColor =
                Number(arr[1]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[2]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[3]?.toString().replace("\r", "").replace('"', ""));

              const newColor =
                Number(arr[5]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[6]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[7]?.toString().replace("\r", "").replace('"', ""));
              listLayers.push({
                LayerName: arr[0].toString().replace("\r", "").replace('"', ""),
                IndexColor: oldColor,
                NewLayerName: (arr[4] || "")
                  .toString()
                  .replace("\r", "")
                  .replace('"', ""),
                NewIndexColor: newColor,
              });
            } else if (arr.length === 6) {
              if (arr[1].includes('"')) {
                //layer cũ - rgb == thay đổi tên layer - màu mới index
                const colorIndex =
                  Number(
                    arr[1]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(
                    arr[2]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(arr[3]?.toString().replace("\r", "").replace('"', ""));

                listLayers.push({
                  LayerName: arr[0]
                    .toString()
                    .replace("\r", "")
                    .replace('"', ""),
                  IndexColor: colorIndex,
                  NewLayerName: arr[4]
                    .toString()
                    .replace("\r", "")
                    .replace('"', ""),
                  NewIndexColor: arr[5].replace("\r", "").replace('"', ""),
                });
              } else if (arr[3].includes('"')) {
                //layer cũ - index == thay đổi tên layer - màu mới rgb
                const colorIndex =
                  Number(
                    arr[3]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(
                    arr[4]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(arr[5]?.toString().replace("\r", "").replace('"', ""));
                listLayers.push({
                  LayerName: arr[0],
                  IndexColor: arr[1].toString().replace("\r", ""),
                  NewLayerName: (arr[2] || "").toString().replace("\r", ""),
                  NewIndexColor: colorIndex,
                });
              }
            } else if (arr.length === 5) {
              //layer cũ - rgb == thay đổi tên layer- không thay đổi màu
              const colorIndex =
                Number(arr[1]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[2]?.toString().replace("\r", "").replace('"', "")) +
                "," +
                Number(arr[3]?.toString().replace("\r", "").replace('"', ""));

              listLayers.push({
                LayerName: arr[0].toString().replace("\r", "").replace('"', ""),
                IndexColor: colorIndex,
                NewLayerName: arr[4]
                  .toString()
                  .replace("\r", "")
                  .replace('"', ""),
                NewIndexColor: colorIndex,
              });
            } else if (arr.length === 4) {
              if (arr[1].includes('"')) {
                //layer cũ - rgb == không thay đổi layer
                const colorIndex =
                  Number(
                    arr[1]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(
                    arr[2]?.toString().replace("\r", "").replace('"', "")
                  ) +
                  "," +
                  Number(arr[3]?.toString().replace("\r", "").replace('"', ""));

                listLayers.push({
                  LayerName: arr[0]
                    .toString()
                    .replace("\r", "")
                    .replace('"', ""),
                  IndexColor: colorIndex,
                  NewLayerName: "",
                  NewIndexColor: "",
                });
              } else {
                //layer cũ - index == layer mới - màu mới index
                listLayers.push({
                  LayerName: arr[0],
                  IndexColor: arr[1].toString().replace("\r", ""),
                  NewLayerName: arr[2].toString().replace("\r", ""),
                  NewIndexColor: arr[3].toString().replace("\r", ""),
                });
              }
            } else if (arr.length === 3) {
              //layer cũ - index == thay đổi name - không thay đổi màu
              listLayers.push({
                LayerName: arr[0],
                IndexColor: arr[1].toString().replace("\r", ""),
                NewLayerName: arr[2].toString().replace("\r", ""),
                NewIndexColor: arr[1].toString().replace("\r", ""),
              });
            } else if (arr.length === 2) {
              //layer cũ - index == không layer mới
              listLayers.push({
                LayerName: arr[0],
                IndexColor: arr[1].toString().replace("\r", ""),
                NewLayerName: "",
                NewIndexColor: "",
              });
            }
          }
        }
        console.log(listLayers);
        function isNumeric(str) {
          if (typeof str != "string") return false;
          return !isNaN(str) && !isNaN(parseFloat(str));
        }

        for (let index = 0; index < listLayers.length; index++) {
          const element = listLayers[index];

          if (element?.IndexColor) {
            if (element.IndexColor.includes(".")) {
              toast.error(
                "CSVのデータが間違っています。もう一度チェックしてください。",
                {
                  position: "bottom-center",
                  autoClose: 4000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                }
              );
              return;
            }
            if (element.IndexColor.includes(",")) {
              const arrColors = element.IndexColor.split(",");
              if (arrColors.length !== 3) {
                toast.error(
                  "CSVのデータが間違っています。もう一度チェックしてください。",
                  {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  }
                );
                return;
              }
              if (
                (element?.IndexColor !== undefined &&
                  !isNumeric(arrColors[0].replace("\r", ""))) ||
                Number(arrColors[0].replace("\r", "")) < 0 ||
                Number(arrColors[0].replace("\r", "")) > 255 ||
                !isNumeric(arrColors[1].replace("\r", "")) ||
                Number(arrColors[1].replace("\r", "")) < 0 ||
                Number(arrColors[1].replace("\r", "")) > 255 ||
                !isNumeric(arrColors[2].replace("\r", "")) ||
                Number(arrColors[2].replace("\r", "")) < 0 ||
                Number(arrColors[2].replace("\r", "")) > 255 ||
                arrColors[0].includes(".") ||
                arrColors[1].includes(".") ||
                arrColors[2].includes(".")
              ) {
                toast.error(
                  "CSVのデータが間違っています。もう一度チェックしてください。",
                  {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  }
                );
                return;
              }
            } else if (
              (element?.IndexColor !== undefined &&
                !isNumeric(element?.IndexColor.toString().replace("\r", ""))) ||
              Number(element?.IndexColor.toString().replace("\r", "")) < 0 ||
              Number(element?.IndexColor.toString().replace("\r", "")) > 255
            ) {
              toast.error(
                "CSVのデータが間違っています。もう一度チェックしてください。",
                {
                  position: "bottom-center",
                  autoClose: 4000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                }
              );
              return;
            }
          }
          if (element?.NewIndexColor) {
            if (element.NewIndexColor.includes(".")) {
              toast.error(
                "CSVのデータが間違っています。もう一度チェックしてください。",
                {
                  position: "bottom-center",
                  autoClose: 4000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                }
              );
              return;
            }
            if (element?.NewIndexColor.includes(",")) {
              const arrColors = element?.NewIndexColor.split(",");
              if (arrColors.length !== 3) {
                toast.error(
                  "CSVのデータが間違っています。もう一度チェックしてください。",
                  {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  }
                );
                return;
              }
              if (
                (element?.NewIndexColor !== undefined &&
                  element?.NewIndexColor !== "" &&
                  !isNumeric(arrColors[0].replace("\r", ""))) ||
                Number(arrColors[0].replace("\r", "")) < 0 ||
                Number(arrColors[0].replace("\r", "")) > 255 ||
                !isNumeric(arrColors[1].replace("\r", "")) ||
                Number(arrColors[1].replace("\r", "")) < 0 ||
                Number(arrColors[1].replace("\r", "")) > 255 ||
                !isNumeric(arrColors[2].replace("\r", "")) ||
                Number(arrColors[2].replace("\r", "")) < 0 ||
                Number(arrColors[2].replace("\r", "")) > 255 ||
                arrColors[0].includes(".") ||
                arrColors[1].includes(".") ||
                arrColors[2].includes(".")
              ) {
                toast.error(
                  "CSVのデータが間違っています。もう一度チェックしてください。",
                  {
                    position: "bottom-center",
                    autoClose: 4000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                  }
                );
                return;
              }
            } else if (
              (element?.NewIndexColor !== undefined &&
                element?.NewIndexColor !== "" &&
                !isNumeric(
                  element?.NewIndexColor.toString().replace("\r", "")
                )) ||
              Number(element?.NewIndexColor.toString().replace("\r", "")) < 0 ||
              Number(element?.NewIndexColor.toString().replace("\r", "")) > 255
            ) {
              console.log("element?.NewIndexColor", element);
              toast.error(
                "CSVのデータが間違っています。もう一度チェックしてください。",
                {
                  position: "bottom-center",
                  autoClose: 4000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                }
              );
              return;
            }
          }
        }
        setListNames(listLayers);
        toast.success("CSV読み込み完了。", {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      };
      fileReader.readAsText(realFileInput.files[0]);
    }
  }

  function handleImportReadCsvClick() {
    const realFileInput = document.getElementById("input-file");
    realFileInput.click();
  }

  function handleExportCSV() {
    const labelFileName = document.querySelector(".file--name label");
    console.log(labelFileName.innerHTML);
    if (labelFileName.innerHTML !== "ファイル名: ") {
      ExportTableToCSV(
        labelFileName.innerHTML
          .replace("ファイル名: ", "")
          .replace(".dwg", "") + ".csv"
      );
    } else {
      ExportTableToCSV("renameBlocks.csv");
    }
  }

  async function handleInputDownloadFolder(e) {
    var files = e.target.files;
    var path = files[0].webkitRelativePath;
    const dirHandle = await window.showDirectoryPicker();
    console.log(files[0], dirHandle);
    var Folder = path.split("/");
    console.log(Folder[0]);
  }

  const handleRename = async () => {
    const preWord = document.getElementById("pre").value;
    const subWord = document.getElementById("sub").value;
    var data = [];
    var listDuplicate = [];
    var listNewNames = [];
    var listNewTableData = [];

    //Nếu có prefix và subfix
    if (preWord !== "" || subWord !== "") {
      var rows = document.querySelectorAll("#contents-table tr");
      for (var i = 0; i < rows.length; i++) {
        var cols = rows[i].querySelectorAll("td, th");
        cols[3].classList.remove("error-cell");
        cols[3].classList.remove("warning-cell");
        const valueColOldName = cols[0].innerText;
        const valueColOldColor = cols[2].innerText;
        const valueColNewName = cols[3].innerText;
        const valueColNewColor = cols[5].innerText;

        if (valueColOldName === "0") {
          var color = valueColOldColor;
          if (valueColNewColor) {
            color = valueColNewColor;
          }
          data.push({
            oldLayerName: "0",
            oldColor: valueColOldColor,
            newLayerName: "0",
            newColorIndex: color,
          });

          listNewTableData.push({
            LayerName: "0",
            IndexColor: color,
            NewLayerName: "",
            NewIndexColor: "",
          });
          listNewNames.push("0");
          continue;
        }

        if (valueColNewName !== "" && valueColOldName !== "") {
          if (valueColNewColor !== "") {
            data.push({
              oldLayerName: valueColOldName,
              oldColor: valueColOldColor,
              newLayerName: preWord + valueColNewName + subWord,
              newColorIndex: valueColNewColor,
            });
            listNewTableData.push({
              LayerName: preWord + valueColNewName + subWord,
              IndexColor: valueColNewColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
          } else {
            data.push({
              oldLayerName: valueColOldName,
              oldColor: valueColOldColor,
              newLayerName: preWord + valueColNewName + subWord,
              newColorIndex: valueColOldColor,
            });
            listNewTableData.push({
              LayerName: preWord + valueColNewName + subWord,
              IndexColor: valueColOldColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
          }
          listNewNames.push(preWord + valueColNewName + subWord);
        } else {
          if (valueColOldName !== "") {
            if (valueColNewColor !== "") {
              data.push({
                oldLayerName: valueColOldName,
                oldColor: valueColOldColor,
                newLayerName: preWord + valueColOldName + subWord,
                newColorIndex: valueColNewColor,
              });

              listNewTableData.push({
                LayerName: preWord + valueColOldName + subWord,
                IndexColor: valueColNewColor,
                NewLayerName: "",
                NewIndexColor: "",
              });
              listNewNames.push(preWord + valueColOldName + subWord);
            } else {
              data.push({
                oldLayerName: valueColOldName,
                oldColor: valueColOldColor,
                newLayerName: preWord + valueColOldName + subWord,
                newColorIndex: valueColOldColor,
              });

              listNewTableData.push({
                LayerName: preWord + valueColOldName + subWord,
                IndexColor: valueColOldColor,
                NewLayerName: "",
                NewIndexColor: "",
              });
              listNewNames.push(preWord + valueColOldName + subWord);
            }
          }
        }
      }
      if (listNewNames.length !== 0) {
        listDuplicate = FindTheSameBlockNameInArray(listNewNames);
      }
    } else {
      var rows = document.querySelectorAll("#contents-table tr");
      for (var i = 0; i < rows.length; i++) {
        var cols = rows[i].querySelectorAll("td, th");
        cols[3].classList.remove("error-cell");
        const valueColOldName = cols[0].innerText;
        const valueColOldColor = cols[2].innerText;
        const valueColNewName = cols[3].innerText;
        const valueColNewColor = cols[5].innerText;

        if (valueColOldName === "0" && valueColNewName !== "") {
          var color = valueColOldColor;
          if (valueColNewColor) {
            color = valueColNewColor;
          }
          data.push({
            oldLayerName: "0",
            oldColor: valueColOldColor,
            newLayerName: "0",
            newColorIndex: color,
          });

          listNewTableData.push({
            LayerName: "0",
            IndexColor: color,
            NewLayerName: "",
            NewIndexColor: "",
          });
          listNewNames.push("0");
          continue;
        }

        if (valueColNewName !== "") {
          if (valueColNewColor) {
            data.push({
              oldLayerName: valueColOldName,
              oldColor: valueColOldColor,
              newLayerName: valueColNewName,
              newColorIndex: valueColNewColor,
            });
            listNewTableData.push({
              LayerName: valueColNewName,
              IndexColor: valueColNewColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
          } else {
            data.push({
              oldLayerName: valueColOldName,
              oldColor: valueColOldColor,
              newLayerName: valueColNewName,
              newColorIndex: valueColOldColor,
            });
            listNewTableData.push({
              LayerName: valueColNewName,
              IndexColor: valueColOldColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
          }
          listNewNames.push(valueColNewName);
        } else {
          if (valueColNewColor) {
            data.push({
              oldLayerName: valueColOldName,
              oldColor: valueColOldColor,
              newLayerName: valueColOldName,
              newColorIndex: valueColNewColor,
            });
            listNewTableData.push({
              LayerName: valueColOldName,
              IndexColor: valueColNewColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
            listNewNames.push(valueColOldName);
          } else {
            listNewNames.push(valueColOldName);
            listNewTableData.push({
              LayerName: valueColOldName,
              IndexColor: valueColOldColor,
              NewLayerName: "",
              NewIndexColor: "",
            });
          }
        }
      }
      if (listNewNames.length !== 0) {
        listDuplicate = FindTheSameBlockNameInArray(listNewNames);
      }
    }
    console.log("listNewNames", listNewTableData);
    console.log("listDuplicate", listDuplicate);

    if (listDuplicate.length > 0) {
      console.log("error");
    } else {
      const labelFileName = document.querySelector(".file--name label");
      if (labelFileName.innerHTML === "ファイル名: ") {
        toast.error(
          "AutoCADファイルを見つかりません。ファイルを選択してください。",
          {
            position: "bottom-center",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
        return;
      }

      if (data.length === 0) {
        toast.error(
          "データが変換されていません。もう一度チェックしてください。",
          {
            position: "bottom-center",
            autoClose: 4000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
        return;
      }

      var formatData = [];
      data.forEach((e) => {
        formatData.push({
          OldLayerName: e.oldLayerName,
          NewLayerName: e.newLayerName,
          NewColorIndex: e.newColorIndex,
        });
      });

      const inputParams = { InputParams: formatData };
      console.log(inputParams);
      // tạo task...
      setProgressIsRunning(true);
      setMessageProgress("画層名を変換しています。しばらくお待ちください。");
      setShowDialog(true);

      const responseRunReNameLayer = await runRenameLayers(jobId, inputParams);
      if (responseRunReNameLayer?.status !== 200) {
        setProgressIsRunning(false);
        setMessageCompleted("画層名を変換出来ませんでした。");
        return;
      }
      // check status by id
      const workId = responseRunReNameLayer.data.id;

      const checkIntervalID = setInterval(async () => {
        try {
          const responseWorkStatus = await ForgeAPI.GetWorkStatus(workId);
          if (responseWorkStatus.status !== 200) {
            clearInterval(checkIntervalID);
            setProgressIsRunning(false);
            setMessageCompleted("画層名を変換出来ませんでした。");
          }

          const listSuccessStatus = [1, 2, 9];
          if (!listSuccessStatus.includes(responseWorkStatus.data.status)) {
            clearInterval(checkIntervalID);
            setProgressIsRunning(false);
            setMessageCompleted("画層名を変換出来ませんでした。");
          } else {
            if (responseWorkStatus.data.status === 9) {
              console.log("responseWorkStatus", responseWorkStatus);
              clearInterval(checkIntervalID);
              await UpdateViewWhenWorkDone();
              // ToDo Work success
            }
          }
        } catch (error) {
          console.log(error);
          clearInterval(checkIntervalID);
          setProgressIsRunning(false);
          setMessageCompleted("画層名を変換出来ませんでした。");
        }
      }, 3000);

      async function UpdateViewWhenWorkDone() {
        //call api mới get new urn
        let newUrn = "";
        const response = await getResultUrn(jobId);
        console.log(response);
        if (response?.status === 200) {
          newUrn = response.data.encodedSourceUrn;
        } else {
          console.log(newUrn);
          setProgressIsRunning(false);
          setMessageCompleted("画層名を変換出来ませんでした。");
        }
        // interval get manifest
        const manifestID = setInterval(async () => {
          console.log("manifestID");
          if (newUrn !== "") {
            const status = await getManifest(newUrn);

            if (status === "success") {
              console.log("update list name");
              setProgressIsRunning(false);
              setMessageCompleted("画層名の変換が完了しました。");
              const urn = "urn:" + newUrn;
              const accessToken = await getAccessToken();
              setViewInfor({
                urn: urn,
                accessToken: accessToken,
              });
              RemoveColNewLayerName();
              setListNames(listNewTableData);
              clearInterval(manifestID);
            }
          }
        }, 3000);

        // Clear Interval when failed
        const idTimeOut = setTimeout(() => {
          clearInterval(checkIntervalID);
          clearInterval(manifestID);
          clearTimeout(idTimeOut);
          setProgressIsRunning(false);
          setMessageCompleted("画層名を変換出来ませんでした。");
        }, 60000 * 3);
      }
    }
    document.getElementById("pre").value = "";
    document.getElementById("sub").value = "";
  };

  const FindTheSameBlockNameInArray = (listBlockNames) => {
    const toFindDuplicates = (listBlockNames) => {
      let lowerList = [...listBlockNames];
      lowerList = lowerList.map((x) => x.toLowerCase());
      return listBlockNames.filter(
        (item, index) => lowerList.indexOf(item.toLowerCase()) !== index
      );
    };
    function getAllIndexes(arr, val) {
      let arrLowerCase = [...arr].map((x) => x.toLowerCase());
      var indexes = [],
        i = -1;
      while ((i = arrLowerCase.indexOf(val.toLowerCase(), i + 1)) !== -1) {
        indexes.push(i);
      }
      return indexes;
    }
    const duplicateElement = toFindDuplicates(listBlockNames);

    function validateName(listNames) {
      let listNameError = [];
      var format = /[*="|<>?,./\\;]/;
      for (let index = 0; index < listNames.length; index++) {
        const element = listNames[index];
        if (format.test(element)) {
          listNameError.push(element);
        }
      }
      return listNameError;
    }

    const listNameError = validateName(listBlockNames);

    if (listNameError?.length > 0) {
      toast.error(
        "ブロック名が間違っています。もう一度チェックしてください。",
        {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
      var rows = document.querySelectorAll("#contents-table tr");
      for (let index = 0; index < listNameError.length; index++) {
        const value = listNameError[index];
        const listIndex = getAllIndexes(listBlockNames, value);
        for (let jIndex = 0; jIndex < listIndex.length; jIndex++) {
          const j = listIndex[jIndex];
          var cell = rows[j].querySelectorAll("td, th")[3];
          cell.className += " warning-cell";
        }
      }
    }

    if (duplicateElement?.length > 0) {
      toast.error(
        "指定された新しい画層名が他と重複しています。もう一度チェックしてください。",
        {
          position: "bottom-center",
          autoClose: 4000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        }
      );
    }
    var rows = document.querySelectorAll("#contents-table tr");
    for (let index = 0; index < duplicateElement.length; index++) {
      const value = duplicateElement[index];
      const listIndex = getAllIndexes(listBlockNames, value);
      console.log(listIndex);
      console.log(value);
      for (let jIndex = 0; jIndex < listIndex.length; jIndex++) {
        const j = listIndex[jIndex];
        var cell = rows[j].querySelectorAll("td, th")[3];
        cell.className += " error-cell";
      }
    }

    return duplicateElement.concat(listNameError);
  };

  async function runRenameLayers(jobId, data) {
    try {
      const response = await RenameLayerApi.RunRenameLayers(jobId, data);
      return response;
    } catch (error) {
      console.log("Run Rename Layers Name", error);
      return null;
    }
  }
  // function API

  async function getResultUrn(jobId) {
    try {
      const response = await RenameLayerApi.GetResultUrn(jobId);
      return response;
    } catch (error) {
      console.log("get Result Urn", error);
      return null;
    }
  }

  async function getAccessToken() {
    try {
      const response = await ForgeAPI.GetViewerToken();
      return response.data.accessToken;
    } catch (error) {
      console.log("Get Viewer Token ", error);
      return null;
    }
  }

  async function getManifest(urn) {
    try {
      const response = await ForgeAPI.GetManifest(urn);
      return response.data.status;
    } catch (error) {
      console.log("Get Manifest ", error);
      return null;
    }
  }
  return (
    <div className="other--btn">
      <div className="import-csv">
        <button
          className={classNames({
            "button-class": true,
            "button-disable": btnDisable,
          })}
          style={{ width: "135px" }}
          onClick={handleExportCSV}
          disabled={btnDisable}
        >
          <FontAwesomeIcon className="icon-class" icon={faFileExport} />
          CSV書き出し
        </button>
        <input
          type="file"
          id="input-file"
          accept=".csv"
          onClick={handleInputCsvClick}
          onChange={handleInputCSVChange}
        />
        <button
          className={classNames({
            "button-class": true,
            "button-disable": btnDisable,
          })}
          id="custom-button"
          style={{ width: "135px" }}
          onClick={handleImportReadCsvClick}
          disabled={btnDisable}
        >
          <FontAwesomeIcon className="icon-class" icon={faFileImport} />
          CSV読み込み
        </button>
      </div>

      <div className="btn-api">
        <button
          className={classNames({
            "button-class": true,
            "button-disable": btnDisable,
          })}
          style={{
            width: "135px",
            minWidth: "135px",
          }}
          onClick={handleRename}
          disabled={btnDisable}
        >
          変換
        </button>
        <input
          type="file"
          id="download-file"
          webkitdirectory="true"
          multiple
          onChange={handleInputDownloadFolder}
        />
        <button
          className={classNames({
            "button-class": true,
            "button-disable": btnDisable,
          })}
          style={{ width: "135px", minWidth: "135px" }}
          onClick={handleDownload}
          disabled={btnDisable}
        >
          <FontAwesomeIcon className="icon-class" icon={faDownload} />
          ダウンロード
        </button>
      </div>
    </div>
  );
}
